// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"96fb6770","213":"1e3573a7","239":"53f31d54","453":"29685622","455":"47c68498","796":"a73e85d6"}[chunkId] + ".chunk.js";
};